import { DataBean } from "../DataBean";

export class InfoForTaxReporting extends DataBean {



    public async getInfoForTaxReportingCatalog(ID:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getInfoForTaxReportingCatalog_String", [ID]);
    }
    
  public async deleteInfoForTaxReporting(IDInfoForTaxReporting:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteInfoForTaxReporting_Number", [IDInfoForTaxReporting]);
    }
     public async updateInfoForTaxReporting(bean:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.admin.InfoForTaxReporting_updateInfoForTaxReporting_com.quickdataerp.bean.admin.InfoForTaxReporting", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.admin.InfoForTaxReporting"
            }
        ]);
    }
 
}